import { render, staticRenderFns } from "./SwitchMetocean.vue?vue&type=template&id=35e4b5fe&"
import script from "./SwitchMetocean.vue?vue&type=script&lang=js&"
export * from "./SwitchMetocean.vue?vue&type=script&lang=js&"
import style0 from "./SwitchMetocean.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports